import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { commaFormatNumber, capitalize, replaceCitations } from '@Utils/String';
import * as qbHelpersService from '@Services/QBHelpers';
import { Flyout } from '@els/els-react--flyout';
import HoverTooltip from '@Components/HoverTooltip';
import { Checkbox } from '@els/els-react--checkbox';
import { Icon } from '@els/els-react--icon';
import { ButtonWithIcon } from '@els/els-react--button';
import { useDispatch } from 'react-redux';
import { recordCountOrTotalResultFromHistoryItem } from '@Containers/PatentFamilyClustering/selectors';
import GroupTitle from '../GroupTitle/GroupTitle';
import { onPropUnSelectAction, onToggleFindAnyAction } from '../../QueryletActions';

import './QueryletHeader.scss';

function QueryletHeader({ node, parent, isGrouped, isDragging, onToggleQuerylet }) {
  const dispatch = useDispatch();

  return (
    <>
      <div
        className={classname('ql__prop__header', {
          'ql__prop__header--group': isGrouped,
        })}>
        {/* title for form  */}
        {node.id === 'wrapper' && !node.groupName && (
          <div className="ql__prop__header--group--title">
            <Icon
              id="layerIcon"
              color="secondary"
              size="s"
              className="u-els-margin-right-1o2"
              sprite={node.canExist && node.items && node.items.length > 1 ? 'Layers' : 'Layer'}>
              {node.displayName}
            </Icon>
            <span className="ql__prop--name cursor-move" aria-label={node.displayName}>
              {node.displayName}
            </span>
          </div>
        )}
        {/* title for ql */}
        {node.id !== 'wrapper' && node.type !== 'history' && (
          <>
            {node.displayName.length > 25 && !isDragging && (
              <Flyout
                flyout={node.displayName.length > 25 && node.displayName}
                shouldCloseOnESC
                placement="bottom-start"
                ariaAttribute="none"
                trigger="hover"
                theme="simple"
                pointerType="primary">
                <span className="ql__prop--name cursor-move" aria-label={node.displayName}>
                  {qbHelpersService.getPropName(node.displayName)}
                </span>
              </Flyout>
            )}
            {node.displayName.length <= 25 && (
              <span className="ql__prop--name cursor-move" aria-label={node.displayName}>
                {qbHelpersService.getPropName(node.displayName)}
              </span>
            )}
          </>
        )}
        {node.groupName && !node.isImmutable && <GroupTitle groupTitle={node} nodelist={parent} />}
        {node.type === 'history' && (
          <>
            {node.id !== 'wrapper' && <Icon id="history" sprite="Folder" a11y={{ name: 'Folder Icon', description: 'Folder Icon' }} />}
            <div className="ql__prop__title">
              {commaFormatNumber(recordCountOrTotalResultFromHistoryItem(node))}&nbsp;
              <span className="replace-citations">{capitalize(replaceCitations(node.context))}</span>
            </div>
          </>
        )}
      </div>
      {/* this code is for numeric querylet */}
      {node.canExist && (
        <div className="ql__prop__openquerylet" id={node.uuid}>
          <Checkbox
            label="Find Any"
            className="ql__prop__openquerylet--checkbox"
            id={node.uuid}
            disabled={node.openQuerylet && !node.isCompact}
            checked={node.exist}
            shouldHideLabel
            onChange={() => {
              dispatch(onToggleFindAnyAction(node));
            }}
          />
          <span className="ql__prop__openquerylet--findanytext">Find Any</span>
          {!node.isCompact && (
            <ButtonWithIcon
              sprite={!node.openQuerylet ? 'ChevronDown' : 'ChevronUp'}
              className="ql__prop__openquerylet--togglefield u-els-margin-right u-els-margin-left"
              iconRight
              type="link"
              onClick={() => {
                onToggleQuerylet(node);
              }}>
              {node.openQuerylet ? 'Hide fields' : 'Show fields'}
            </ButtonWithIcon>
          )}
          {!node.openQuerylet && node.children && node.children.length && (
            <span className="ql__prop__openquerylet--summary">{qbHelpersService.getSummary(node.children)}</span>
          )}
          <div className="ql__prop__openquerylet--deletebutton">
            <HoverTooltip theme="simple" tooltip="Delete Querylet" tooltipPlace="bottom">
              <ButtonWithIcon
                id="closeQuerylet"
                sprite="Trash"
                className="ql__prop__openquerylet"
                iconOnly
                type="link"
                a11y={{ name: 'Delete Querylet', description: 'Delete Querylet' }}
                onClick={() => {
                  dispatch(onPropUnSelectAction(node.uuid, parent));
                }}>
                Delete Querylet
              </ButtonWithIcon>
            </HoverTooltip>
          </div>
        </div>
      )}
    </>
  );
}

QueryletHeader.propTypes = {
  node: PropTypes.object,
  parent: PropTypes.array,
  isGrouped: PropTypes.bool,
  isDragging: PropTypes.bool,
  onToggleQuerylet: PropTypes.func,
};

export default QueryletHeader;
